import React from 'react';
import { Progress } from "@/components/ui/progress";

export default function AnalysisProgress({ progress, currentStep }) {
  return (
    <div className="bg-white p-8 rounded-lg border text-center space-y-6">
      <h2 className="text-2xl font-semibold">Analyse en cours...</h2>
      <p className="text-gray-600">{currentStep || "Initialisation..."}</p>
      <Progress value={progress} className="w-full h-3" />
      <p className="text-sm text-gray-400">{progress}%</p>
    </div>
  );
}
